import React, { useState, useEffect } from 'react';
import { logger } from '../utils/logger';
import { Card, CardContent } from './ui/card';
import { Loader2, Instagram } from 'lucide-react';
import { getCases } from '../services/api';
import { OptimizedImage } from './OptimizedImage';

export const CasesSection = () => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchCases = async () => {
      try {
        setLoading(true);
        const data = await getCases();
        setCases(data);
        setError(null);
      } catch (err) {
        logger.error('Failed to fetch cases:', err);
        setError('Kon projecten niet laden');
      } finally {
        setLoading(false);
      }
    };
    
    fetchCases();
  }, []);
  
  return (
    <section id="inspiratie" className="cases-section py-20 bg-white scroll-mt-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-sweet-sans text-3xl sm:text-4xl font-normal text-earth-brown mb-6 uppercase tracking-wide">
            Inspiratie & Projecten
          </h2>
          <p className="font-sweet-sans text-sm text-almost-black/80 max-w-2xl mx-auto">
            Ontdek hoe onze manden tot leven komen in diverse interieurs
          </p>
        </div>
        
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 text-terra-beige animate-spin" />
          </div>
        ) : error ? (
          <div className="text-center py-12 text-red-600">{error}</div>
        ) : (
          <>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {cases.map((caseItem, index) => (
                <Card key={caseItem.id} className="overflow-hidden border-terra-beige/20">
                  <div className="aspect-[4/3] overflow-hidden bg-white">
                    <OptimizedImage
                      src={caseItem.image} 
                      alt={caseItem.title}
                      objectFit="cover"
                      objectPosition={index === 2 ? "50% 75%" : "center"}
                      className="w-full h-full"
                      sizes="(max-width: 768px) 100vw, 33vw"
                    />
                  </div>
                  <CardContent className="p-6">
                    <h3 className="font-sweet-sans text-xl font-normal text-earth-brown mb-2 uppercase tracking-wide">
                      {caseItem.title}
                    </h3>
                    <p className="font-sweet-sans text-sm text-almost-black/70 leading-relaxed">
                      {caseItem.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
            
            {/* Instagram Link Section */}
            <div className="max-w-3xl mx-auto text-center">
              <div className="bg-gradient-to-r from-terra-beige/10 via-terra-beige/20 to-terra-beige/10  p-8 border-2 border-terra-beige/30">
                <Instagram className="w-12 h-12 text-terra-beige mx-auto mb-4" />
                <h3 className="font-sweet-sans text-3xl sm:text-4xl font-normal text-earth-brown mb-3 uppercase tracking-wide">
                  Meer inspiratie op Instagram
                </h3>
                <p className="font-sweet-sans text-almost-black/70 mb-6">
                  Volg ons voor dagelijkse inspiratie, behind-the-scenes en de nieuwste projecten
                </p>
                <a 
                  href="https://instagram.com/l.art.be" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-earth-brown font-sweet-sans text-sm uppercase tracking-wider underline hover:text-earth-brown/70 transition-colors duration-200 font-bold"
                >
                  Bezoek onze Instagram
                </a>
                <p className="font-sweet-sans text-sm text-almost-black/60 mt-4">
                  @l.art.be — Volg ons voor meer projecten en inspiratie
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};